"use strict";
exports.__esModule = true;
exports.DEFAULT_INTERVAL = exports.DEFAULT_ITEM_WIDTH = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("@sportnet/utilities");
var CenteredHeader_1 = tslib_1.__importDefault(require("../../../view/components/Header/CenteredHeader"));
var FullFlat_1 = tslib_1.__importDefault(require("./Modes/FullFlat"));
var FullRotation_1 = tslib_1.__importDefault(require("./Modes/FullRotation"));
var List_1 = tslib_1.__importDefault(require("./Modes/List"));
var SingleRotation_1 = tslib_1.__importDefault(require("./Modes/SingleRotation"));
exports.DEFAULT_ITEM_WIDTH = 250;
exports.DEFAULT_INTERVAL = 2000;
var Products = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    var items = utilities_1.getProp(data, ['data', 'items'], []).map(function (i) { return (tslib_1.__assign(tslib_1.__assign({}, i), { url: data.baseUri ? data.baseUri + "/produkt/" + i.url : null })); });
    var width = !data.width || data.width < 1 ? exports.DEFAULT_ITEM_WIDTH : data.width;
    var interval = !data.interval || data.interval < 1000 ? exports.DEFAULT_INTERVAL : data.interval;
    var invalid = !data.mode || !items.length;
    if (invalid && renderEmpty) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty(data.type));
    }
    if (invalid) {
        return null;
    }
    var content = null;
    switch (data.mode) {
        case 'full-flat':
            content = react_1["default"].createElement(FullFlat_1["default"], { items: items, width: width });
            break;
        case 'full-rotation':
            content = react_1["default"].createElement(FullRotation_1["default"], { items: items, width: width });
            break;
        case 'single-rotation':
            content = (react_1["default"].createElement(SingleRotation_1["default"], { items: items, width: width, interval: interval }));
            break;
        case 'list':
            content = react_1["default"].createElement(List_1["default"], { items: items });
            break;
        default:
            break;
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        data.title && react_1["default"].createElement(CenteredHeader_1["default"], null, data.title),
        content));
};
exports["default"] = Products;
